import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

// Build timestamp injected at build time
declare const __BUILD_TIME__: string;

export function Footer() {
  const { t } = useTranslation();
  const buildTime = typeof __BUILD_TIME__ !== 'undefined' ? __BUILD_TIME__ : '';

  return (
    <footer className="container py-6 text-center text-sm text-muted-foreground">
      <p>{t("footer.copyright")}</p>
      <div className="flex justify-center gap-4 mt-2">
        <Link to="/terms" className="hover:text-primary">
          {t("footer.terms")}
        </Link>
        <Link to="/privacy" className="hover:text-primary">
          {t("footer.privacy")}
        </Link>
        <Link to="/contact" className="hover:text-primary">
          {t("footer.contact")}
        </Link>
        <a
          href="https://archivision-landing.web.app"
          target="_blank"
          rel="noopener noreferrer"
          className="hover:text-primary"
        >
          ARchiVision
        </a>
      </div>
      {buildTime && (
        <p className="mt-4 text-xs text-muted-foreground/70">
          Build: {buildTime}
        </p>
      )}
    </footer>
  );
}
